import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";

import { showTaskList, updateTaskList } from "../../../../../MyApi/crm/tasks";



import NoteModal from "../NoteModal";
import AdminsCard from "../AdminsCard";
import ModeratorsCard from "../ModeratorsCard";
import EmployesCard from "../EmployesCard";
import TaskCardDetails from "../TaskCardDetails";
import TaskListCard from "../TaskListCard";
import LoadingSpinner from "../../../../UI/spinner";

import classes from "./taskShow.module.css";
import TimeLineModal from "../TimeLineModal";
import AttachModal from "../AttachModal";


const TasksDetalis = ({ tasks, refetch }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNoteModalOpen, setIsNoteModalOpen] = useState(false);
  const[ isAttachModalOpen ,setIsAttachModalOpen ]=useState(false)
   const [selectedId , setSelectedId] = useState("")
  const {data ,isLoading ,refetch:refetchshow}= useQuery(["showTasklist" ,selectedId] ,()=> showTaskList(selectedId),{
    enabled:!!selectedId
  })

  const mutation = useMutation(
    "postupdateTask",
    (postData) => updateTaskList(postData),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
        refetch();
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`);
      },
    }
  );

  const openModal = (id) => {
    setIsModalOpen(true);
    setSelectedId(id)
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openNoteModal = (id) => {
    setIsNoteModalOpen(true);
    setSelectedId(id)
  };
  const closeNoteModal = () => {
    setIsNoteModalOpen(false);
  };
  const openAttachModal =(id)=>{
    setIsAttachModalOpen(true)
    setSelectedId(id)
  }
  const closeAttachModal =()=>{
    setIsAttachModalOpen(false)
  }

  const handlePostRequest = (id ,status) => {
    mutation.mutate({
      id,
      status,
    });
  };
 

  const {
    id,
    company,
    name,
    branch,
    start_date,
    end_date,
    status,
    active,
    lists,
    employes,
    admins,
    moderators,
  } = tasks;
 if(isLoading){
  return <LoadingSpinner/>
 }
  
  return (
    <div className={classes.container}>
      <div className="row user-profile">
       <TaskCardDetails id={id} name={name} company={company} branch={branch} start_date={start_date} end_date={end_date} status={status} active={active}/>
       <TaskListCard lists={lists} classes={classes} openAttachModal={openAttachModal} openNoteModal={openNoteModal}  handlePostRequest={handlePostRequest} isModalOpen={isModalOpen} openModal={openModal} closeModal={closeModal}/>
      </div>
      <div className="row">
       <EmployesCard employes={employes}/>
      <AdminsCard admins={admins}/>
      <ModeratorsCard moderators={moderators}/>   
      </div>
      {isNoteModalOpen && <NoteModal crm_task_id={id} crm_task_list_id={selectedId} refetch={refetchshow}  data={data}  closeModal={closeNoteModal}/>}
      {isModalOpen &&  <TimeLineModal data={data}    closeModal={closeModal} /> }
      {isAttachModalOpen&& <AttachModal data={data}  closeModal={closeAttachModal} />}
    </div>
  );
};

export default TasksDetalis;
